import type { NakamaConfig } from '@aliza/nakama-client';

export function getNakamaConfig(): NakamaConfig {
  return {
    host: import.meta.env.VITE_NAKAMA_HOST || '127.0.0.1',
    port: import.meta.env.VITE_NAKAMA_PORT || '7350',
    serverKey: import.meta.env.VITE_NAKAMA_SERVER_KEY || 'defaultkey',
    useSSL: import.meta.env.VITE_NAKAMA_USE_SSL === 'true',
    timeout: 7000,
    autoRefreshSession: true,
  };
}
